export const CITIES_ENDPOINT = 'recruitment/api/cities';
export const COUNTRIES_ENDPOINT = 'recruitment/api/countries';
export const TECHNOLOGIES_ENDPOINT = 'recruitment/api/technologies';
export const AGENCIES_ENDPOINT = 'api/agencies';

export const ELASTICSEARCH_RECRUITMENT_REINDEX = 'recruitment/api/elasticsearch/index';
export const ELASTICSEARCH_SUPPLIERS_REINDEX = 'suppliers/api/elasticsearch/index';
